import React, { useEffect, useMemo, useState } from 'react';
import TableComponent from 'app/components/TableComponent';
import { Modal } from 'react-bootstrap-v5';
import './styles/perfil.css';
import { KTSVG } from '_metronic/helpers/components/KTSVG';
import { InputModalText } from 'app/components/InputsComponents/InputModalText';
import { InputModalSelect } from 'app/components/InputsComponents/InputModalSelect';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { getAllProfiles, getAllProfilesFilterCode, getAllProfilesFilterDesc, profileCreateAndUpdate } from 'app/service/configuration/Perfiles';
import { ProfileType } from 'app/types/configuracion/perfiles';
import axios from 'axios';
import { FilterView } from 'app/components/FilterView';
import { ESTATUS } from 'app/utilities/constants';

const API_URL = process.env.REACT_APP_API_NET;
const heads = [
    { code: 'code', label: 'Código' },
    { code: 'description', label: 'Descripción' },
    { code: 'departamento', label: 'Departamento' },
    { code: 'estatus', label: 'Estatus' },
];

const PerfilView: React.FC = () => {
    const [submitWithoutStatusValidation, setSubmitWithoutStatusValidation] = useState(false);
    const [loadingGrid, setLoadingGrid] = useState<boolean>(true);
    const [show, setShow] = useState(false);
    const [showFilterModal, setShowFilterModal] = useState<boolean>(false);
    const [selectedDepartment, setSelectedDepartment] = useState<string>('');

    const [isFiltered, setIsFiltered] = useState<boolean>(false);
    const [employeeName, setEmployeeName] = useState<string>('');
    const [employeeNumber, setEmployeeNumber] = useState<string>('');
    const [selectedOption, setSelectedOption] = useState<string>('');

    const [perfiles, setPerfiles] = useState<ProfileType[]>([]);
    const [departments, setDepartments] = useState<{ [key: number]: string }>({});
    const [selectOptionDepartments, setSelectOptionDepartments] = useState<[]>([]);

    const [currentPage, setCurrentPage] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(5);
    const [totalRecords, setTotalRecords] = useState<number>(0);

    const [id, setId] = useState<number | undefined | null>(null);

    const fetchAllDepartments = async (): Promise<void> => {
        try {
            const res = await axios.get(`${API_URL}Department`);
            setSelectOptionDepartments(res.data.data.records.map((record: any) => ({ id: record.id, description: record.description })));
        } catch (err) {
            console.error("Error fetching departments ", err);
        }
    }

    const fetchDepartmentId = async (id: number): Promise<void> => {
        if (departments[id]) return;

        try {
            const resDepartment = await axios.get(`${API_URL}Department/${id}`);
            const departmentName = resDepartment.data.data?.name || 'Desconocido';

            setDepartments((prev) => ({ ...prev, [id]: departmentName }));
            setLoadingGrid(false);
        } catch (err) {
            console.error("Error fetching departments id", err);
            setDepartments((prev) => ({ ...prev, [id]: 'No tiene departamento' }));
        }
    }

    const fetchProfiles = async (): Promise<void> => {
        try {
            setLoadingGrid(true);
            const res = await getAllProfiles(currentPage, pageSize);

            setPerfiles((res!.records ?? []).map((record) => ({
                ...record,
                status: record?.statusId === 1 ? 'Activo' : 'Inactivo',
            })));

            setTotalRecords(res!.totalRecords); //Aqui le pongo 0 xd
        } catch (err) {
            console.error("Error fetching perfiles ", err)
        } finally {
            setLoadingGrid(false);
        }
    }

    const PerfilesSchema = Yup.object().shape({
        code: Yup.string()
            .required('Este campo es requerido')
            .min(3, "Mínimo 3 caracteres")
            .max(5, "Máximo 5 caracteres"),
        description: Yup.string()
            .required('Este campo es requerido')
            .min(3, "Mínimo 3 caracteres")
            .max(100, "Máximo 100 caracteres"),
        departamento: Yup.number()
            .required('Este campo es requerido')
            .notOneOf([0], "Seleccione una opción"),
        obligatory: Yup.number()
            .when([], {
                is: () => !submitWithoutStatusValidation,
                then: Yup.number()
                    .required('Este campo es requerido')
                    .notOneOf([0], "Seleccione una opción"),
                otherwise: Yup.number(),
            }),
    });

    const formPerfil = useFormik<any>({
        validationSchema: PerfilesSchema,
        initialValues: {
            code: '',
            description: '',
            departamento: 0,
            obligatory: 0,
        },
        onSubmit: async (values, { setSubmitting }) => {
            const { code, description, departamento } = values;
            try {
                await profileCreateAndUpdate(
                    {
                        ...values,
                        code: code.toUpperCase(),
                        description: description,
                        idDepartament: Number(departamento),
                        status: Number(values?.obligatory),
                        id: id
                    }
                );
                setEmployeeName('');
                setEmployeeNumber('');
                setSelectedOption('');
                setIsFiltered(false);
                
                fetchProfiles();
            } catch (err) {
                console.error('Error', err);
            } finally {
                setSubmitting(false);
            }
            formPerfil.resetForm();
            handleClose();
        },
    });

    //Falta en el back el error 204 No Content
    useEffect(() => {
        if (isFiltered) {
            if (selectedOption === '1' && employeeName) {
                getAllProfilesFilterCode(currentPage, pageSize, employeeName).then(res => {
                    if (res === null) {
                        setTotalRecords(0);
                        return setPerfiles([]);
                    }
                    setPerfiles((res!.records ?? []).map((record) => ({
                        ...record,
                        status: record?.statusId === 1 ? 'Activo' : 'Inactivo',
                    })));
                    setTotalRecords(res!.totalRecords ?? 0);
                });
            }
            if (selectedOption === '2' && employeeNumber) {
                getAllProfilesFilterDesc(currentPage, pageSize, employeeNumber).then(res => {
                    if (res === null) {
                        console.warn("NO HAY NADA")
                        setTotalRecords(0);
                        return setPerfiles([]);
                    }
                    setPerfiles((res!.records ?? []).map((record) => ({
                        ...record,
                        status: record?.statusId === 1 ? 'Activo' : 'Inactivo',
                    })));
                    setTotalRecords(res!.totalRecords ?? 0);
                });
            }
        } else {
            fetchProfiles();
            fetchAllDepartments();
        }
    }, [currentPage, pageSize, isFiltered, employeeName, employeeNumber]);

    useEffect(() => {
        const departmentIds = perfiles
            .map((p) => p.departmentId)
            .filter((id): id is number => id !== undefined && !departments[id]);

        departmentIds.forEach((id) => fetchDepartmentId(id));
    }, [perfiles]);

    const rows = useMemo(() => {
        if (!loadingGrid && perfiles.length) {
            return perfiles.map((row) => ({
                code: (
                    <div
                        style={{ textAlign: 'center' }}
                    >
                        {row.code}
                    </div>
                ),
                description: (
                    <div
                        onClick={() => {
                            handleShow();
                            setSubmitWithoutStatusValidation(false);
                            formPerfil.setValues({ code: row.code, description: row.description, departamento: row.departmentId, obligatory: row.statusId });
                            setId(row.id);
                        }}
                        style={{ cursor: 'pointer', color: 'blue' }}
                    >
                        {row.description}
                    </div>
                ),
                departamento: (
                    <div style={{ textAlign: 'center' }}>
                        {row.departmentId !== undefined ? departments[row.departmentId] ?? 'Cargando...' : 'Desconocido'}
                    </div>
                ),
                estatus: (
                    <div style={{ textAlign: 'center' }}>{row.status}</div>
                ),
            }));
        }
        return [];
    }, [perfiles, loadingGrid, departments]);

    const handleClose = () => {
        setShow(false);
        setSelectedDepartment('');
        setId(null);
        formPerfil.resetForm();
    };

    const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setSelectedOption(e.target.value);
    };

    const handleShow = (codigo?: string) => {
        setSelectedDepartment(codigo || ''); //no codigo
        setShow(true);
    };

    const toggleFilterModal = () => {
        setId(null);
        setShowFilterModal((prev) => !prev);
    };

    return (
        <div className="row gy-5 g-xl-8">
            <div className="col-xxl-12 col-xl-12 col-md-12 col-lg-12">
                <div className="card card-flush p-5">
                    <div className="d-flex justify-content-between align-items-center mb-5">
                        <h3 className="fw-bold fs-4">Perfil</h3>
                        <div className="d-flex justify-content-end gap-2">
                            <button
                                className="btn btn-light-primary border-btn"
                                onClick={() => { setSubmitWithoutStatusValidation(true); handleShow(); }}
                            >
                                <KTSVG
                                    path="/media/icons/duotune/abstract/abs011.svg"
                                    className="svg-icon-2 svg-icon-gray-500 "
                                />
                            </button>
                            <button className="btn btn-light-primary border-btn w-10" onClick={toggleFilterModal}>
                                <KTSVG
                                    path="/media/icons/duotune/general/gen021.svg"
                                    className="svg-icon-5 svg-icon-gray-500"
                                />
                                <span className="ms-2">Filtrar</span>
                            </button>
                        </div>
                    </div>
                    <TableComponent
                        heads={heads}
                        rows={rows}
                        rowsPerPage={pageSize}
                        page={currentPage}
                        totalRows={totalRecords}
                        setPage={setCurrentPage}
                    />
                </div>
            </div>

            {/* Modal para perfiles */}
            <Modal
                id="kt_modal_perfiles"
                tabIndex={-1}
                dialogClassName="modal-dialog"
                show={show}
                onHide={handleClose}
            >
                <div className="modal-content">
                    <div className="modal-header">
                        <h1 className="text-muted">Perfiles</h1>
                        <div
                            className="btn btn-sm btn-icon btn-active-color-primary"
                            onClick={handleClose}
                        >
                            <KTSVG
                                className="svg-icon-2"
                                path="/media/icons/duotune/arrows/arr061.svg"
                            />
                        </div>
                    </div>
                    <div className="modal-body mx-5">
                        <form className="form needs-validation" noValidate onSubmit={(e) => { e.preventDefault(); formPerfil.handleSubmit(); }}>
                            {/* Código */}
                            <InputModalText
                                formFormik={formPerfil}
                                label={'Codigo'}
                                htmlFor={'code'}
                                name={'code'}
                                placeholder={'Ingrese el código'}
                                width='100'
                                styleBootstrapClasses='mb-5'
                            />
                            {/* Descripción */}
                            <InputModalText
                                formFormik={formPerfil}
                                label={'Descripción'}
                                htmlFor={'description'}
                                name={'description'}
                                placeholder={'Ingrese la descripción'}
                                width='100'
                                styleBootstrapClasses='mb-5'
                            />
                            {/* Departamento */}
                            <InputModalSelect
                                selectOptions={selectOptionDepartments}
                                formFormik={formPerfil}
                                label={'Departamento'}
                                htmlFor={'departamento'}
                                name={'departamento'}
                                width={'100'}
                            />
                            {/* Estado */}
                            <InputModalSelect
                                selectOptions={ESTATUS}
                                formFormik={formPerfil}
                                label={'Estado'}
                                htmlFor={'obligatorio'}
                                name={'obligatory'}
                                width='100'
                                styleBootstrapClasses='mb-5'
                                show={!submitWithoutStatusValidation}
                            />
                            {/* Botones */}
                            <div className="d-flex justify-content-between mt-4">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    style={{ backgroundColor: '#f5f5f5', color: '#000' }}
                                    onClick={handleClose}
                                >
                                    Cancelar
                                </button>
                                <button
                                    type="submit"
                                    className="btn btn-danger"
                                    style={{ backgroundColor: '#ff4d4f', borderColor: '#ff4d4f' }}
                                >
                                    Guardar
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </Modal>

            {/* Modal para el Filtro */}
            <Modal
                id="kt_modal_filter"
                tabIndex={-1}
                dialogClassName="modal-dialog"
                show={showFilterModal}
                onHide={toggleFilterModal}
            >
                {showFilterModal && (
                    <FilterView
                        handleFilterClose={toggleFilterModal}
                        handleSelectChange={handleSelectChange}
                        selectedOption={selectedOption}
                        employeeName={employeeName}
                        employeeNumber={employeeNumber}
                        setEmployeeName={setEmployeeName}
                        setEmployeeNumber={setEmployeeNumber}
                        setSelectedOption={setSelectedOption}
                        setCurrentPage={setCurrentPage}
                        setIsFiltered={setIsFiltered}
                        fetchData={() => fetchProfiles()}
                        fetchFilterData={() => getAllProfilesFilterCode(currentPage, pageSize, employeeName)}
                        fetchFilterData2={() => getAllProfilesFilterDesc(currentPage, pageSize, employeeNumber)}
                    />
                )}
            </Modal>
        </div>
    );
};

export { PerfilView };